import { render, staticRenderFns } from "./TimeExten.vue?vue&type=template&id=7845450d"
import script from "./TimeExten.vue?vue&type=script&lang=ts"
export * from "./TimeExten.vue?vue&type=script&lang=ts"
import style0 from "./TimeExten.vue?vue&type=style&index=0&id=7845450d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports